import { type SorterResult } from 'antd/es/table/interface';
import { antdTableSortToDirection } from '../../components/table/TableColumnSort.tsx';
import { getPagination } from './getPagination.ts';

/**
 * Converte l'ordinamento di una colonna antd nel parametro `ordinamenti`
 * delle API (`campo` crescente, `-campo` decrescente), preferendo il
 * `sortDataIndex` della colonna. Ritorna `undefined` se l'ordinamento è
 * stato rimosso.
 */
export function getSorterOrdering<T>(
  sorter: SorterResult<T> | SorterResult<T>[],
): string[] | undefined {
  // Le tabelle gestiscono l'ordinamento su una sola colonna
  const { order, field, column } = sorter as SorterResult<T>;

  return getPagination({
    sort: (column?.sortDataIndex ?? field) as string | undefined,
    direction: antdTableSortToDirection(order),
  }).ordinamenti;
}
